/* eslint-disable @typescript-eslint/member-ordering */
import { Component, ElementRef, HostBinding, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core'
import { IPet } from '@app/models/pet'
import { IPetDetails } from '@app/models/pet-details'
import { OrchestratorService } from '@app/services/orchestrator.service'
import { firstValueFrom } from 'rxjs'

interface IActivePets {
	PetName: string;
	Age: number;
	Sex: string;
	BreedName: string;
	ActiveClaims: 0;
	Species: string;
	PetId: string;
	PetPicUrl: unknown;
	CustomPic: boolean;
	Links: unknown;
	actions: unknown;
	actionLinks: unknown;
}

@Component({
	selector: 'mv-myvets-notification',
	templateUrl: './myvets-notification.component.html',
	styleUrls: ['./myvets-notification.component.scss'],
})
export class MyvetsNotificationComponent implements OnInit {
	public activePetDetails: IPet[] = []
	private _activePets: IActivePets[] | string = []
	@HostBinding('attr.data-emb-element') embAttribute = true
	@HostListener('window:emb_mv:global_update')
	handleUpdateEvent (): void {
		this.getActivePetDetails()
	}
	@Input()
	get activePets (): IActivePets[] | string {
		return this._activePets
	}
	set activePets (value: IActivePets[] | string) {
		this._activePets = value
		this.getActivePetDetails()
	}
	@Output() emb_mv_add_vet: EventEmitter<string> = new EventEmitter<string>()
	@HostBinding('attr.aria-hidden')
	get isVisible (): boolean {
		return this.activePetDetails
			.map(p => p.providers)
			.some(p => !p.length)
	}

	constructor (
		private readonly orchestratorService: OrchestratorService,
		public readonly el: ElementRef<HTMLElement>,
	) { }

	ngOnInit (): void {
		this.getActivePetDetails()
	}

	public handleAddVet (petId: string): void {
		const addVetEvent: CustomEvent = new CustomEvent(
			'emb_mv:global_add_vet',
			{
				bubbles: true,
				detail: petId,
			},
		)
		this.emb_mv_add_vet.emit(petId)
		this.el.nativeElement.dispatchEvent(addVetEvent)
	}

	private async getActivePetDetails (): Promise<void> {
		if (!this.activePets?.length) return
		let parsedPets: IActivePets[]
		if (typeof this.activePets === 'string') {
			parsedPets  = JSON.parse(this.activePets ?? [])
		} else {
			parsedPets = this.activePets
		}
		const petRequests: Array<Promise<IPetDetails>> = parsedPets
			.map(pet => firstValueFrom(this.orchestratorService.getPetDetails(pet.PetId)))

		try {
			const result = await Promise.all(petRequests).then(pets => pets.map(p => p.pet))
			this.activePetDetails = result
		} catch (err) {
			console.error(err)
		}

		return
	}

}
